<template>
  <div :class="classObj" class="app-wrapper" v-auto-height="60">
    <sidebar class="sidebar-container" :routes="routes"></sidebar>
    <div class="main-container">
      <transition name="fade" mode="out-in">
        <!-- <router-view :key="key"></router-view> -->
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar/index'
// import Breadcrumb from '@/components/Breadcrumb'
import adminRoutes from '@/router/admin'
// import ResizeMixin from './mixin/ResizeHandler'

const Layout = {
  name: 'Layout',
  components: {
    Sidebar,
    // Breadcrumb
  },
  // mixins: [ResizeMixin],
  data() {
    return {
      // routes:
    }
  },
  computed: {
    routes() {
      return adminRoutes
    },
    classObj() {
      return {
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        // withoutAnimation: this.sidebar.withoutAnimation,
        // mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
  }
}
export default Layout

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  // .main-container {
  //   background: #fff;
  // }
  .drawer-bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    z-index: 999;
    background: #000;
  }
</style>
